import { actionCreator } from '@blink/components/src/utils';

import {
    GET_AGREEMENTS,
    GET_USER_WALLET_BALANCE,
    SET_AGREEMENTS_LOADING_FALSE,
    SET_LENDER_AGREEMENTS,
    SET_BORROWER_AGREEMENTS,
    SET_USER_BORROWS,
} from './constants';

import { Agreement, ROLE } from '@/shared/api/borrow';

export const getAgreementsAction = (payload: { role?: ROLE; withoutCache?: boolean }) =>
    actionCreator(GET_AGREEMENTS, payload);

export const getUserWalletBalanceAction = (payload: { role?: ROLE; withoutCache?: boolean }) =>
    actionCreator(GET_USER_WALLET_BALANCE, payload);

export const setUserBorrows = (payload: Agreement[]) => actionCreator(SET_USER_BORROWS, payload);

export const setAgreementsLoadingFalseAction = () => actionCreator(SET_AGREEMENTS_LOADING_FALSE);

export const setLenderAgreementsAction = (payload: Agreement[]) =>
    actionCreator(SET_LENDER_AGREEMENTS, payload);

export const setBorrowerAgreementsAction = (payload: Agreement[]) =>
    actionCreator(SET_BORROWER_AGREEMENTS, payload);
